import React, { createContext, useState } from 'react'
export const codivascontext = createContext([]);